// @ts-strict-ignore
import { CommonModule } from "@angular/common";
import { Component, OnInit } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { RadioButtonModule } from "primeng/radiobutton";
import { InputTextModule } from "primeng/inputtext";
import { TableModule } from "primeng/table";
import { ErrorCheck } from "src/app/shared/models/error-check.model";
import { ProgressCheck } from "src/app/shared/models/progress-check.model";
import { SharedDirectivesModule } from "src/app/shared/shared-directives.module";
import { LabeledFieldComponent } from "src/app/shared/components/forms/labeled-field/labeled-field.component";
import * as C from "../../../../../../shared/constants/globals.constants";
import { EWizDynamicBaseClassComponent } from "src/app/modules/esim/shared/classes/ewiz-dynamic.class";
import { DataService } from "src/app/shared/services/data.service";
import * as ProfileModel from "src/app/shared/models/profile.model";
import { ErrorMessageComponent } from "src/app/modules/esim/shared/components/error-message/error-message.component";

@Component({
  selector: C.EWIZ_EQUIVALENT_HOME_PLMN_CONFIGURATION,
  templateUrl: "./equivalent-home-plmn-configuration.component.html",
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    RadioButtonModule,
    InputTextModule,
    TableModule,
    SharedDirectivesModule,
    LabeledFieldComponent,
    ErrorMessageComponent
  ]
})
export class EWizEquivalentHomePLMNConfigurationComponent
  extends EWizDynamicBaseClassComponent
  implements OnInit, ErrorCheck, ProgressCheck
{
  constructor(private dataService: DataService) {
    super();
  }

  ngOnInit() {
    this.errorCheck(this.profileValues, this.dataService);
  }

  convertToNull(value: string): string | null {
    return value === "" ? null : value;
  }
  errorCheck(values: ProfileModel.ProfileDto, dataService: DataService) {
    // Always reset error values to default state prior to executing check
    this.errorFound = false;
    this.errorMessage = "";

    if (values.equivalentHomePLMN && +values.useEquivalentHomePLMN === 1) {
      for (const record of values.equivalentHomePLMN) {
        if (!dataService.isNullOrEmpty(record.mobileCountryCode) && record.mobileCountryCode.length < 3) {
          this.errorMessage = $localize`Mobile Country Codes must be 3 digits in length`;
          this.errorFound = true;
        }
        if (!dataService.isNullOrEmpty(record.mobileNetworkCode) && record.mobileNetworkCode.length < 2) {
          this.errorMessage = $localize`Mobile Network Codes must be 2 or 3 digits in length`;
          this.errorFound = true;
        }
      }
    }

    return this.errorFound;
  }

  progressCheck(values: ProfileModel.ProfileDto, dataService: DataService) {
    let oneCompleteRecord = false;

    if (values.useEquivalentHomePLMN === null) {
      return false;
    } else if (+values.useEquivalentHomePLMN === 0) {
      return true;
    } else if (values.equivalentHomePLMN && +values.useEquivalentHomePLMN === 1) {
      for (const record of values.equivalentHomePLMN) {
        const hasCountryCode = !dataService.isNullOrEmpty(record.mobileCountryCode);
        const hasNetworkCode = !dataService.isNullOrEmpty(record.mobileNetworkCode);

        if (hasCountryCode && !hasNetworkCode) {
          return false;
        } else if (hasNetworkCode && !hasCountryCode) {
          return false;
        } else if (hasCountryCode && hasNetworkCode) {
          oneCompleteRecord = true;
        }
      }
    }

    if (!oneCompleteRecord) {
      return false;
    }

    return true;
  }

  updateEquivalentHomePLMN() {
    if (this.profileValues.equivalentHomePLMN && +this.profileValues.useEquivalentHomePLMN === 1) {
      this.profileValues.usimServiceTable.usimService71 = true;
    } else {
      this.profileValues.usimServiceTable.usimService71 = false;
    }

    this.handleFormEvents();
  }
}
